<template>
  	<div class="main-menu" v-b-hover="handleMoreNav" id="headMenu" :class="[isHovered ? 'main-menu-hover' : '']">
  		<div class="container menu-content">
  			<div class="row">
  			<div class="col-md-1 logo">
  				<a href="/" class="logo">VIA WATCH</a>
  			</div>

  			<ul class="col-md-8 menu">
  				<li><a href="#" class="menu-item">Watches</a>
  					<ul class="subnav" v-show="isHovered">
              <li><router-link :to="{path: 'watchlist',query:{goodsType: 'bestSale'}}">Best Sale</router-link></li>
              <li><router-link :to="{path: 'watchlist',query:{goodsType: 'newArrival'}}">New Arriva</router-link></li>
  					  <li><a href="#">Brands</a></li>
  					</ul>
  				</li>
  				<li><a href="#" class="menu-item">Auction</a>
  					<ul class="subnav" v-show="isHovered">
  					  <li><a href="#">Open Lots</a></li>
  					  <li><a href="#">Live Auction</a></li>
  					</ul>
  				</li>
  				<li><a href="#" class="menu-item">Service</a>
  					<ul class="subnav" v-show="isHovered">
  					  <li><a href="#">Maintenance</a></li>
  					  <li><a href="#/sell">Sell a Watch</a></li>
  					  <li><a href="#">Trade a Watch</a></li>
  					</ul>
  				</li>
  				<li><a href="#" class="menu-item">Article</a>
  					<ul class="subnav" v-show="isHovered">
  					  <li><a href="#">Open Lots</a></li>
              <li><a href="#">Live Auction</a></li>
  					</ul>
  				</li>
  				<li><a href="#" class="menu-item">FAQ</a></li>
  			</ul>
        <!-- :class="[isHovered ? 'bg-white' : '']" -->
  			<div class="col-md-3">
          <div class="search">
            <i class="icons"></i>
            <input type="text" placeholder="Search" ref="input" class="Ainput" @focus="handleSearchFocus('searchContent')" @keyup.enter="handleSearchBlur"  v-model="searchContent" />
          </div>
        </div>
  			</div>
  		</div>
  		<div class="clearfix"></div>
  		<div class="menu-prd" v-show="isHovered">
  			<ol class="container">
  				<li class="menu-prd-item" v-for="(item,index) in hotGoodsList" :key="index">
  					<a @click="goodsDetail(item.goodsId)"><div class="menu-prd-img">
            <img :src="item.picUrl" alt="" style="width: 150px;height: 150px;"></div>
  						<b class="prd-brand">{{item.brandName}}</b>
  						<p class="prd-name">{{item.goodsName}}</p>
  						<span class="prd-price" v-if="item.webPrice">{{item.webPrice}}</span>
              <span class="prd-price" else>{{item.originalPrice}}</span>
  					</a>
  				</li>
  			</ol>
  			<div class="clearfix"></div>
  		</div>
  		<div class="search-box" v-show="searchFocus">
  			<div class="container">
  				<ul class="row">
  					<li class="col-md-3"></li>
  					<li class="col-md-4 ps">
  					  <ol class="dd">
  							<h3>POPULAR SEARCHES</h3>
  							<li v-for="(item,index) in hotList" :key="index">
                   <a :style="[{cursor:'pointer',display:'inline-block','padding-top': index === 0? '12px':'4px'}]" @click="tiaoNew(item)">{{ item }}</a>
                <!--  <a v-if="index==0" @click="tiaoNew(item)" style="cursor:pointer;padding-top: 50px">{{item}}111</a>
                  <a v-else @click="tiaoNew(item)" style="cursor:pointer;padding-top: 4px">{{item}}</a>-->
                  </li>
  						</ol>
  					</li>
  					<li class="col-md-5 rs">
  						<ol class="dd">
  							<h3>RECENT SEARCHES</h3>
  							<li v-for="(item,index) in keyWordList" :key="index" v-if="index<10">
  							  <router-link :to="{path: 'watchlist',query:{name: item}}">{{item}}</router-link>
  							  </li>
  							<span class="clear-btn">
                  <span @click.prevent="deleteKey()" style="cursor:pointer;"> CLEAR</span></span>
  						</ol>
  					</li>
  				</ul>
  			</div>
  		</div>


  	</div>
</template>

<script>
import {selectListByType} from '@/api/watchList'
import {hotWordByCode} from '@/api/index'
export default {
  name: 'MainMenu',
  data() {
    return {
    	isHovered: false,
    	searchFocus: false,
      searchContent: undefined,
      hotList: [],
      keyWordList: [],
      hotGoodsList: []

    }
  },
  created() {
    this.init()
  },
  // watch: {
  //   searchContent: {
  //     handler(val) {
  //       if (val) {
  //         console.log('这是什么鬼')
  //          // this.searchFocus = true
  //       }else{
  //          this.searchFocus = false
  //       }
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    init(){
      //初始化数据
      var words = localStorage.getItem('keyword')
      if(words){
        var keys = words.split(',')
        this.keyWordList=keys.reverse()
      }
      selectListByType({goodsType:'hot',isShow: 1}).then(response=>{
        this.hotGoodsList=response.data.data.list
      })
      hotWordByCode({name: '热词'}).then(response=>{
        console.log(response.data.data.list)
        this.hotList=response.data.data.list
      })
    },
    tiaoNew(name){
      this.$router.push({path: 'watchlist',query:{name: name}}, () => {})
    },
    handleMoreNav(hovered) {
      if (hovered) {
      	this.isHovered = hovered
      } else if (!this.searchFocus) {
      	this.isHovered = hovered
        this.$refs.input.blur()
      }else if(this.searchFocus){
        this.searchFocus=hovered
        this.isHovered=hovered
        this.$refs.input.blur()
      }
    },
    handleSearchFocus(type) {
    	this.searchFocus = true;
    },
    searchBlur(){
      console.log('触发')
      this.searchFocus = false;
    },
    goodsDetail(goodsId){
     this.$router.push({ path: 'watchpage', query: { id: goodsId }}, () => {})
    },
    handleSearchBlur() {
      console.log('进来了')
      if(this.searchContent){
        //存入缓存
        var keyword=localStorage.getItem("keyword")
        if(keyword){
          if(!keyword.includes(this.searchContent)){
            localStorage.setItem("keyword",keyword+','+this.searchContent)
          }
        }else{
           localStorage.setItem("keyword",this.searchContent)
        }
        keyword=localStorage.getItem('keyword')
        this.keyWordList=keyword.split(',').reverse()
        this.searchFocus = false
        this.$refs.input.blur()
        // this.searchContent = undefined
        this.$router.push({ path: 'watchlist', query: { name: this.searchContent }}, () => {})
      }else{
       this.$router.push({ path: 'watchlist', query: {}}, () => {})
      }
    },
    handleCloeNav() {
    	var sp = document.getElementById("headNav")
    	if (!sp.contains(event.target)) {
    		this.searchFocus = false;
    		this.isHovered = false;
        this.$refs.input.blur()
        this.searchContent = undefined
    	}
    },
    deleteKey(){
      this.searchFocus = true;
      localStorage.removeItem('keyword')
      this.keyWordList=[]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue